import { render, staticRenderFns } from "./ProfilePreview.vue?vue&type=template&id=7de4f5b6&"
import script from "./profile-preview.js?vue&type=script&lang=js&"
export * from "./profile-preview.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports